import React, { Component } from 'react';
import { Accordion, Card, InputGroup, FormControl } from 'react-bootstrap';
import { Col, Row } from 'react-bootstrap';
import { get } from './../../utility/apiClient';
import { errorTypesEnum } from './../../utility/enums';
import MessageBox from '../../components/common/messageBox/MessageBox';
import LoadingScreen from '../../components/loadingScreen/LoadingScreen';
import './DeliveryGrid.scss';

/**-- Imports for redux --*/
import { connect } from 'react-redux';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';
import { Button } from '../common';


// map the redux states to props
function mapStateToProps(state) {
    return {
        loadingScreenVisible: state.loadingScreen
    }
};

// map the redux actions to props
const mapDispatchToProps = {
    showMessageBox,
    showLoadingScreen,
    hideLoadingScreen
};

class DeliveryGrid extends Component {
    state = {
        selectedAccordion: '',
        mainCityList: [],
        filteredList: [],
        searchTerm: ""
    };

    componentDidMount() {
        this.props.showLoadingScreen();
        get('/DeliveryCity/GetCity').then(response => {
            if (response.data.statusCode === 200) {
                this.setState({
                    mainCityList: response.data.result,
                    filteredList: response.data.result
                })
            } else {
                let errorType = response.data.errorList[0].errorType;
                let messageBox = {
                    show: true,
                    title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                    className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                    content: response.data.errorList[0].statusMessage,
                    isConfirmation: false,
                    callBackFunction: null
                }
                this.props.showMessageBox(messageBox);
            }
            this.props.hideLoadingScreen();
        })
    };

    searchCity() {
        if (this.state.searchTerm) {
            let withSuburbs = this.state.mainCityList.filter(x => x.suburbs.length > 0);
            let filteredResult = withSuburbs.filter(x => {
                return x.suburbs.some(y => y.suburbName.toLowerCase().includes(this.state.searchTerm.toLowerCase()))
            })
            let cities = this.state.mainCityList.filter(x => x.cityName.toLowerCase().includes(this.state.searchTerm.toLowerCase()));
            let citiesNotInResult = cities.filter(x => !filteredResult.includes(x));
            if (citiesNotInResult) {
                filteredResult = filteredResult.concat(citiesNotInResult)
            }

            this.setState({
                filteredList: filteredResult
            });
        }
    }

    resetSearch() {
        this.setState({
            filteredList: this.state.mainCityList,
            searchTerm: ""
        })
    }

    render() {
        return (
            <React.Fragment>
                <Col md="12" className="mt-3 mb-3">
                    <InputGroup>
                        <FormControl className="city-search-input" placeholder="Search for a suburb" value={this.state.searchTerm} onChange={(e) => { this.setState({ searchTerm: e.target.value }) }} />
                        {this.state.searchTerm ?
                            <InputGroup.Append>
                                <Button className="city-reset-search-button" sm secondary onClick={() => this.resetSearch()}>Clear Search</Button>
                            </InputGroup.Append>
                            : null}
                        <InputGroup.Append>
                            <Button className="city-search-button" primary onClick={() => this.searchCity()}>Search</Button>
                        </InputGroup.Append>
                    </InputGroup>
                </Col>
                <Col>
                    <Accordion defaultActiveKey="-1" >
                        <Row className="m-0 row-cols-1 row-cols-xs-1 row-cols-sm-1 row-cols-md-3 row-cols-lg-4">
                            {
                                this.state.filteredList.map((city, index) =>
                                    <div style={{ padding: "10px" }}>
                                        <Card className='border-1 delivery-card-body'>
                                            <div style={{ height: "80px" }}>
                                                <Accordion.Toggle style={{ height: "56px" }} eventKey={index} className='d-flex justify-content-between delivery-card-title-click' as={Card.Header} >
                                                    {city.cityName}<i className="fa fa-plus-circle" style={{ color: "#64BF47" }}></i>
                                                </Accordion.Toggle>
                                                {
                                                    (city.isFull == true) ?
                                                        <span className='text-muted-span' style={{ paddingLeft: "10px" }}>Some of the locations already full</span>
                                                        :
                                                        <span style={{ paddingLeft: "10px" }}> </span>
                                                }
                                            </div>
                                            <Accordion.Collapse eventKey={index} >
                                                <div>
                                                    <hr style={{ width: "90%" }} />
                                                    {
                                                        city.suburbs.map((suburb, index) =>
                                                            <Card.Body className='justify-content-left p-1'>
                                                                <span className={(suburb.isFull == true) ? 'text-muted-span suburb-text' : ''} style={{ paddingLeft: "10px", paddingBottom: "10px" }}>{suburb.suburbName}</span>
                                                            </Card.Body>
                                                        )
                                                    }
                                                </div>
                                            </Accordion.Collapse>
                                        </Card >
                                    </div>
                                )
                            }
                        </Row>
                    </Accordion>
                </Col>
                <MessageBox />
                <LoadingScreen isVisible={this.props.loadingScreenVisible} />
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryGrid);